var _style, _g, _defs, _g2, _path, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectric(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 30",
    style: {
      enableBackground: "new 0 0 110 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EDD53F;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2_1_",
    className: "st0",
    d: "M15,0h80c8.3,0,15,6.7,15,15l0,0c0,8.3-6.7,15-15,15H15C6.7,30,0,23.3,0,15l0,0 C0,6.7,6.7,0,15,0z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 110,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.7,16h-3.9v2.7h4.6v1.6h-6.7v-10h6.7V12h-4.6v2.4h3.9V16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.7,18.7H47v1.6h-6.4v-10h2.1V18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.2,16h-3.9v2.7h4.6v1.6h-6.7v-10h6.7V12h-4.6v2.4h3.9V16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.9,17c-0.1,1.1-0.5,1.9-1.2,2.5c-0.7,0.6-1.7,0.9-2.8,0.9c-1.3,0-2.3-0.4-3-1.3c-0.7-0.9-1.1-2-1.1-3.5V15 c0-1,0.2-1.8,0.5-2.5s0.8-1.3,1.4-1.7c0.6-0.4,1.4-0.6,2.2-0.6c1.1,0,2.1,0.3,2.8,0.9s1.1,1.5,1.2,2.6h-2.1c0-0.6-0.2-1.1-0.5-1.4 c-0.3-0.3-0.8-0.4-1.4-0.4c-0.7,0-1.2,0.2-1.5,0.7c-0.3,0.5-0.5,1.3-0.5,2.3v0.8c0,1.1,0.2,1.9,0.5,2.4c0.3,0.5,0.8,0.7,1.5,0.7 c0.6,0,1.1-0.1,1.4-0.4c0.3-0.3,0.5-0.7,0.5-1.3H63.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.5,12h-3v8.3h-2.1V12h-3v-1.7h8.1V12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.4,16.7h-1.6v3.6h-2.1v-10h3.7c1.2,0,2.1,0.3,2.7,0.8s1,1.3,1,2.2c0,0.7-0.1,1.2-0.4,1.7 c-0.3,0.5-0.7,0.8-1.3,1.1l2.2,4.1v0.1h-2.2L77.4,16.7z M75.7,15h1.7c0.5,0,0.9-0.1,1.2-0.4S79,14,79,13.5c0-0.5-0.1-0.8-0.4-1.1 c-0.3-0.3-0.7-0.4-1.2-0.4h-1.6V15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.8,20.3h-2.1v-10h2.1V20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.5,17c-0.1,1.1-0.5,1.9-1.2,2.5c-0.7,0.6-1.7,0.9-2.8,0.9c-1.3,0-2.3-0.4-3-1.3c-0.7-0.9-1.1-2-1.1-3.5V15 c0-1,0.2-1.8,0.5-2.5s0.8-1.3,1.4-1.7c0.6-0.4,1.4-0.6,2.2-0.6c1.1,0,2.1,0.3,2.8,0.9s1.1,1.5,1.2,2.6h-2.1c0-0.6-0.2-1.1-0.5-1.4 c-0.3-0.3-0.8-0.4-1.4-0.4c-0.7,0-1.2,0.2-1.5,0.7c-0.3,0.5-0.5,1.3-0.5,2.3v0.8c0,1.1,0.2,1.9,0.5,2.4c0.3,0.5,0.8,0.7,1.5,0.7 c0.6,0,1.1-0.1,1.4-0.4c0.3-0.3,0.5-0.7,0.5-1.3H94.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    className: "st1",
    d: "M12.5,9.6c-0.1-0.2,0-0.5,0.3-0.6c0,0,0.1,0,0.1,0h4.7c0.2,0,0.4,0.1,0.4,0.3l2.3,7.5 c0.1,0.2-0.1,0.5-0.3,0.6c0,0-0.1,0-0.1,0h-2.9c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0.1l1.4,5.1c0.1,0.2-0.1,0.5-0.3,0.5 c-0.2,0.1-0.4,0-0.5-0.2l-6.4-8.6c-0.1-0.2-0.1-0.5,0.1-0.6c0.1-0.1,0.2-0.1,0.3-0.1h2.2c0.1,0,0.2-0.1,0.2-0.2c0,0,0,0,0-0.1 L12.5,9.6z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectric);
export default __webpack_public_path__ + "static/media/electric.e37020c2a8827ddd76c110743ec4de81.svg";
export { ForwardRef as ReactComponent };